// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23H1.30049L3.51936 19.006C1.94632 17.1038 1 14.6615 1 12C1 5.92487 5.92487 1 12 1ZM11 6.5V14H13V6.5H11ZM13.0039 15.5H11V17.5039H13.0039V15.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-bubble-error-filled')
export default class ChatBubbleErrorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-bubble-error-filled',
    }
  }
}
